import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';

export const uploadImageToFirebase = async (base64Data, storage, folder, fileName, setNotification) => {
  if (!storage) {
    setNotification({ type: 'error', message: 'Firebase Storage is not available.' });
    return null;
  }
  
  const [mimeType, base64] = base64Data.split(';base64,');
  if (!mimeType || !base64) {
    setNotification({ type: 'error', message: 'Invalid image data format.' });
    return null;
  }
  
  try {
    const blob = await (await fetch(base64Data)).blob();
    const storageRef = ref(storage, `${folder}/${fileName}`);
    const snapshot = await uploadBytes(storageRef, blob);
    const publicUrl = await getDownloadURL(snapshot.ref);

    setNotification({ type: 'success', message: 'Image uploaded to Cloud Storage!' });
    return publicUrl;
  } catch (err) {
    setNotification({ type: 'error', message: `An unexpected error occurred during image upload: ${err.message}` });
    console.error('Firebase upload exception:', err);
    return null;
  }
};

export const deleteImageFromFirebase = async (imageUrl, storage) => {
    if (!imageUrl || !imageUrl.startsWith('https://firebasestorage.googleapis.com')) {
        return;
    }
    try {
        const storageRef = ref(storage, imageUrl);
        await deleteObject(storageRef);
    } catch (error) {
        console.warn("Could not delete image from storage:", error);
    }
};